import { render, staticRenderFns } from "./tableau.vue?vue&type=template&id=3076c737&scoped=true"
import script from "./tableau.vue?vue&type=script&lang=js"
export * from "./tableau.vue?vue&type=script&lang=js"
import style0 from "./tableau.vue?vue&type=style&index=0&id=3076c737&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3076c737",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VRow})
